<template>
<div>
    <smallbutton toplabel="Add Employee Credit" @click="startAdd()" v-if="showButton" class="button"/>
    <linkbutton toplabel="Add Employee Credit" @click="startAdd()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Add Employee Credit {{Employee.Name}}</label>
               

                <br/>
                <br>
                <div class="horizFlexCenter">    
                    
                        <label class="creditlabel" for="amount">Amount $</label>
                        <label class="required">*</label>
                    
                    <input id="amount" class="credittext" type="currency"  name="" ref="amtinput" required="true" v-model="amount"
                        @focus="$event.target.select()" >
                    
                </div>
                <br>
                <div>
                     <label class="">Note: The amount you enter will be ADDED to the existing balance.</label>
                </div>
                
                 <div>
                    <smallbutton  @click="Confirm()" toplabel="Save" :disabled="isSaved"/>
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                 </div>
                
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
export default {
    name:'addemployeecredit',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
    },
    props:{
        Employee:{
            type:Object,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        }
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            insave:false,
            responseMessage:'',
            pleaseWait:false,
            trueParam:true,
            falseParam:false,
            amount:0
            
        }
    },
    computed:{
        ...mapFields([
            'currentWallet',
            'loggedInUser'

        ]),
        
    },
    methods:{
        
       
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        startAdd(){
            this.amount=0
            this.responseMessage=''
            this.$refs.mymodal.openModal()
            this.$nextTick(()=>{
                this.$refs.amtinput.focus();
            });
   
        },
        async Confirm(){
            if(this.insave){return}
            


            if(this.$refs.balform.checkValidity()){
                
                this.insave=true
                this.beforeAPI();
                let req = {
                    personId:this.Employee.personId,
                    locationId:this.Employee.locationId,
                    personCode:this.Employee.studentId,
                    amount:this.amount
                }
                var response = await this.callAPI(req,'addemployeecredit')

                if(response.Successful){
                    this.insave=false
                    
                    //finish up
                    this.responseMessage="Add Employee Credit was successful"
                    this.$emit('refresh')
                    
                }else{
                    this.insave=false
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            }
        },
       
        
       
        
    }
}
</script>

<style>

</style>





























